const serverURL = 'https://geolocater-backend.onrender.com';
export default serverURL;
